const userConstants = {
    SET: 'USER_SET',
    REMOVE: 'USER_REMOVE',
};

export default userConstants;
